module.exports = __webpack_public_path__ + "static/media/google-maps-marker.25a6aff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/google-maps-marker.png
// module id = 1167
// module chunks = 0